import { ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants } from '@festina/life-general-types/life/hooks/ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants'

export const useFetchLifeTenants =
  ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants.useSuspenseQuery
